import useBrazilianIssuer from "components/company/v3/context/hooks/useBrazilianIssuer";
import getMatchedSecurity from "components/company/v3/utils/getMatchedSecurity";
import FundamenteiMetadata from "components/seo/FundamenteiMetadata";
import getBaseUrl from "lib/utils/getBaseUrl";
import { useIntl } from "react-intl";

interface BrazilianIssuerSeoProps {
  tickerSymbol: string;
  title?: string;
  /**
   * Tab-specific summary. It gets prefixed with the ticker symbol and the issuer name so every tab of every issuer
   * still ends up with a unique meta description instead of the generic one.
   */
  description?: string;
}
export default function BrazilianIssuerSeo({ tickerSymbol, title, description }: BrazilianIssuerSeoProps) {
  const intl = useIntl();
  const issuer = useBrazilianIssuer();
  const security = getMatchedSecurity(issuer, tickerSymbol);

  const primaryTickerSymbol = security?.tickerSymbol || issuer.securities[0].tickerSymbol;
  const pageTitle = title
    ? `${primaryTickerSymbol} - ${issuer.name} | ${title} | Fundamentei`
    : `${primaryTickerSymbol} - ${issuer.name}: Cotação, Dividendos, Balanços e Indicadores | Fundamentei`;
  const pageDescription = description
    ? `${primaryTickerSymbol} - ${issuer.name}: ${description}`
    : intl.formatMessage(
        {
          defaultMessage:
            "{primaryTickerSymbol} - {name}: Análise Fundamentalista, Cotação, Balanços atualizados e histórico, Dividendos (DY), Indicadores (P/L, P/VPA) e muito mais!",
          id: "DMTyFD",
        },
        {
          primaryTickerSymbol,
          name: issuer.name,
        },
      );
  const gitShaShort = process.env.GIT_SHA_SHORT || "1";
  const languageCode = intl.locale === "pt-BR" ? "pt-BR" : "en-US";
  const imageUrl = `${getBaseUrl()}/og/issuer/${primaryTickerSymbol.toLowerCase()}?locale=${languageCode}&ns=br&v=${gitShaShort}`;

  return (
    <FundamenteiMetadata
      title={pageTitle}
      description={pageDescription}
      openGraph={{
        images: [
          {
            url: imageUrl,
            width: 1200,
            height: 630,
            alt: `${primaryTickerSymbol} - ${issuer.name}`,
          },
        ],
      }}
    />
  );
}
